export default function unsetCustomErrorMessags({ state }) {
  let { customErrors } = state.get('app')
  customErrors.forEach(error => {
    state.unset(`${error.path}.errorMessages.${error.index}`)
  })
  state.set('app.customErrors', [])
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/unsetCustomErrorMessages.js